import { api } from './api'
import type {
  SubmissionResponse,
  ContactBody,
  SectorSupportBody,
  ExpressInterestBody,
  TenderSupportBody,
  EventRegistrationBody,
  CompanyRegistrationBody,
} from '@/types/submissions'

export const submissionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    submitContact: builder.mutation<SubmissionResponse, ContactBody>({
      query: (body) => ({ url: '/submissions/contact', method: 'POST', body }),
    }),

    submitSectorSupport: builder.mutation<SubmissionResponse, SectorSupportBody>({
      query: (body) => ({ url: '/submissions/sector-support', method: 'POST', body }),
    }),

    submitExpressInterest: builder.mutation<SubmissionResponse, ExpressInterestBody>({
      query: (body) => ({ url: '/submissions/express-interest', method: 'POST', body }),
    }),

    submitTenderSupport: builder.mutation<SubmissionResponse, TenderSupportBody>({
      query: (body) => ({ url: '/submissions/tender-support', method: 'POST', body }),
    }),

    submitEventRegistration: builder.mutation<SubmissionResponse, EventRegistrationBody>({
      query: (body) => ({ url: '/submissions/event-registration', method: 'POST', body }),
    }),

    submitCompanyRegistration: builder.mutation<SubmissionResponse, CompanyRegistrationBody>({
      query: (body) => ({ url: '/submissions/company-registration', method: 'POST', body }),
    }),
  }),
})

export const {
  useSubmitContactMutation,
  useSubmitSectorSupportMutation,
  useSubmitExpressInterestMutation,
  useSubmitTenderSupportMutation,
  useSubmitEventRegistrationMutation,
  useSubmitCompanyRegistrationMutation,
} = submissionsApi
